<template>
  <v-toolbar :color="hasSelectedGuias ? 'rgba(17, 138, 202, 0.1)' : undefined" elevation="0" dense>
    <v-checkbox
      @change="handleCheckboxClick"
      :input-value="selectedAll"
      :indeterminate="indeterminate"
      :disabled="disabled"
      :label="label"
      color="primary"
      hide-details
    />
    <div v-if="hasSelectedGuias" class="primary--text">{{ guiasIds | pluralize }}  de {{ totalGuias }}</div>
    <v-spacer />
    <v-menu
      offset-x
      offset-y
      close-on-click
      close-on-content-click
      v-if="hasSelectedGuias"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" color="primary" outlined>
          AÇÕES
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          v-for="(action, index) in filteredAcoesGuia"
          :key="index"
          :disabled="action.disabled"
          @click="action.onClick"
        >
          <v-list-item-title>{{ action.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import { conciliacaoClient } from '../../../libs/conciliacao-client'

export default {
  props: {
    pagamentoId: String,
    guiasIds: Array,
    totalGuias: Number,
    loteId: String,
    conciliacaoAutomaticaDisabled: Boolean,
    finalizarConciliacaoDisabled: Boolean,
    hasConciliacaoItems: Boolean,
    isUsuarioTradimus: Boolean
  },
  data() {
    return {
      guiasActions: [
        {
          title: 'Invalidar guia',
          onClick: this.handleInvalidarGuiaClick,
          disabled: this.hasConciliacaoItems
        },
        {
          title: 'Executar conciliação automática',
          onClick: this.handleConciliacaoAutomaticaClick,
          disabled: this.conciliacaoAutomaticaDisabled,
          acaoCliente: true
        },
        {
          title: 'Desconciliar guias selecionadas',
          onClick: this.handleDesconciliarClick,
          disabled: this.finalizarConciliacaoDisabled,
          acaoCliente: true
        }
      ],
      limparConciliacaoItens: false,
      limparConciliacaoGuias: false
    }
  },
  computed: {
    hasSelectedGuias () {
      return this.guiasIds.length > 0
    },
    selectedAll () {
      return this.guiasIds.length > 0 && this.guiasIds.length === this.totalGuias
    },
    indeterminate () {
      return this.guiasIds.length > 0 && this.guiasIds.length < this.totalGuias
    },
    disabled () {
      return this.totalGuias === 0
    },
    label () {
      return this.guiasIds.length === 0 ? 'Selecionar todas as guias' : undefined
    },
    filteredAcoesGuia () {
      return this.guiasActions.filter(acao => !this.isUsuarioTradimus ? acao.acaoCliente : true)
    }
  },
  methods: {
    async handleConciliacaoAutomaticaClick () {
      const paramModal = {
        type: "warning",
        title: "Conciliar guias automaticamente",
        message: this.hasConciliacaoItems ? "Confirme a ação que deve ser feita na conciliação automática das guias selecionadas." : "A conciliação automática será executada.",
        callback: () => {
          if (this.hasConciliacaoItems) {
            this.limparConciliacaoItens = true,
            this.limparConciliacaoGuias = false
          }
          this.conciliarAutomaticamente()
         },
        btConfirm: { name: this.hasConciliacaoItems ? "Desconciliar apenas itens" : "Confirmar", show: true },
        btExtra: {
          name: "Desconciliar guia",
          color: 'secondary',
          show: this.hasConciliacaoItems,
          callback: () => {
            this.limparConciliacaoItens = true,
            this.limparConciliacaoGuias = true
            this.conciliarAutomaticamente()
          }
        },
        btCancel: {
          name: "Cancelar",
          show: true
        },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    handleDesconciliarClick (){
      const paramModal = {
        type: "warning",
        title: "Desconciliar guias",
        message: "Esta ação desconciliará todos os itens das guias selecionadas. <br>Esta ação não pode ser desfeita.<br>",
        callback: this.desconciliarGuias,
        btConfirm: { name: "Ok", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    async desconciliarGuias () {
      try {
        const command = {
          pagamentoId: this.pagamentoId,
          data: [{
            pagamentoLoteId: this.loteId,
            pagamentoGuiaIds: this.guiasIds
          }]
        }

        await conciliacaoClient.pagamento.desconciliar(command)
        this.$emit('reloadGuias')
        this.$emit('deselectAllGuias')
      } catch (error) {
        const paramModal = {
          type: "error",
          title: "Invalidar guias",
          message: `Erro ao deletar conciliação. <br/>${error}`,
          btConfirm: { name: "Fechar", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    },
    async conciliarAutomaticamente () {
      try {
        const data = this.guiasIds.map(pagamentoGuiaId => {
          return {
            pagamentoLoteId: this.loteId, pagamentoGuiaId,
            limparConciliacaoItens: this.limparConciliacaoItens,
            limparConciliacaoGuias: this.limparConciliacaoGuias
          }
        })
        await conciliacaoClient.conciliacaoExecucao.createConciliacaoExecucaoBatch({ data })
        this.$emit('reloadGuias')
        this.$emit('deselectAllGuias')
      } catch (error) {
        const paramModal = {
          type: "error",
          title: "Invalidar guias",
          message: `Erro ao executar conciliação automática. <br/>${error}`,
          btConfirm: { name: "Fechar", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    },
    handleCheckboxClick (checked) {
      if (checked) {
        this.$emit('selectAllGuias')
      } else {
        this.$emit('deselectAllGuias')
      }
    },
    handleInvalidarGuiaClick () {
      const paramModal = {
        type: "warning",
        title: "Invalidar guias",
        message: "Esta ação invalidará todos as guias selecionadas e o seus itens.",
        callback: this.invalidarGuia,
        btConfirm: { name: "Ok", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    async invalidarGuia () {
      try {
        const invalidarQuery = {
          pagamentoGuias: this.guiasIds,
          itemValido: false
        }

        await conciliacaoClient.pagamentoItem.updatePagamentoItensItemValido(invalidarQuery)
        this.$emit('reloadGuias')
        this.$emit('deselectAllGuias')
      } catch (error) {
        const paramModal = {
          type: "error",
          title: "Invalidar guias",
          message: `Erro ao invalidar guias. <br/>${error.response?.data?.detail}`,
          btConfirm: { name: "Fechar", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    }
  },
  filters: {
    pluralize (array) {
      const count = array.length
      if (count === 0) {
        return 'Nenhuma guia selecionada'
      } else if (count === 1) {
        return '1 guia selecionada'
      } else {
        return `${count} guias selecionadas`
      }
    }
  }
}
</script>
